import * as path from 'path-browserify';

import fileDownload from '../../../utils/fileDownload';
import api from '../../api';

type SignUploadOptions = {
  filename?: string;
  folder?: string;
  metadata?: ObjectMetadata;
};

type Key = string;

type GetSignedGetObjectPayload = {
  url: string;
  key: string;
};

type ObjectMetadata = {
  public?: string;
};

async function upload(
  file: File,
  options: SignUploadOptions | undefined = {
    filename: undefined,
    folder: undefined,
    metadata: undefined,
  },
): Promise<Key> {
  const client = api();

  const headers = new Headers();
  headers.append('Content-Type', file.type);

  const toBase64 = (fileToConvert: any) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(fileToConvert);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const base64File = await toBase64(file);

  console.log('mimetype', file.type);

  const response = await client.put<GetSignedGetObjectPayload>(
    '/files/signed-put-object',
    {
      filename: file.name,
      mimetype: file.type,
      newFilename: options.filename,
      folder: options.folder,
      metadata: options.metadata,
      file: base64File,
    },
  );

  return response.data.key;
}

async function uploadZip(
  file: File,
  options: SignUploadOptions | undefined = {
    filename: undefined,
    folder: undefined,
    metadata: undefined,
  },
): Promise<Key> {
  const client = api();

  const headers = new Headers();
  headers.append('Content-Type', file.type);

  const toBase64 = (fileToConvert: any) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(fileToConvert);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const base64File = await toBase64(file);

  console.log('mimetype', file.type);

  const response = await client.put<GetSignedGetObjectPayload>(
    '/files/signed-put-zip-object',
    {
      filename: file.name,
      mimetype: file.type,
      newFilename: options.filename,
      folder: options.folder,
      metadata: options.metadata,
      file: base64File,
    },
  );

  return response.data.key;
}

// async function remove(
//   key: Key,
//   userId: string,
//   companyId: string,
//   fileId: string,
// ) {
//   const client = api();
//   const response = await client.delete(`/files/${key}`, {
//     headers: {
//       userId,
//       companyId,
//       fileId,
//     },
//   });

//   return response;
// }

async function updateMetadata(
  key: Key,
  metadata: ObjectMetadata,
  companyId: string,
  userId: string,
): Promise<void> {
  const client = api();
  await client.patch(
    `/files/metadata`,
    { key, metadata },
    {
      headers: {
        companyId,
        userId,
      },
    },
  );
}

function getUrl(key: Key): string {
  return `${process.env.REACT_APP_BACKEND_API_URL}/files/${key}`;
}

async function getBlob(
  key: Key,
  userId: string,
  companyId: string,
): Promise<Blob> {
  const client = api();

  console.log('API userId, companyId', userId, companyId);
  const response = await client.get(getUrl(key), {
    headers: {
      userId,
      companyId,
    },
    responseType: 'blob',
  });

  return response.data;
}

async function download(
  key: Key,
  name: string,
  userId: string,
  companyId: string,
): Promise<void> {
  const blob = await getBlob(key, userId, companyId);

  fileDownload(blob, name);
}

async function getFileUrl(
  key: Key,
  userId: string,
  companyId: string,
): Promise<string> {
  const blob = await getBlob(key, userId, companyId);

  const url = URL.createObjectURL(blob);

  return url;
}

const fileApi = {
  upload,
  // remove,
  getUrl,
  getBlob,
  getFileUrl,
  updateMetadata,
  download,
  uploadZip,
};

export default fileApi;

// upload do zip no pelo front
// chamar a rota de zip enviando apenas a key
// pegar o arquivo do s3 pela key no backend
